// CaisseApi.js - Complete version with all transfer functions
import axios from "axios";
import { getSession } from "../Utils/SessionUtils";

const api_url = process.env.REACT_APP_API;

const getConfig = () => ({
  headers: { Authorization: `Bearer ${getSession("token")}` },
});

export async function getOrCreateCaisse(user_id, organisation_id, nom_caisse) {
  try {
    const response = await axios.post(
      api_url + "caisse/get-or-create",
      { user_id, organisation_id, nom_caisse },
      getConfig(),
    );
    return response;
  } catch (error) {
    return error?.response;
  }
}

export async function getCaissesByOrganisation(organisation_id) {
  try {
    const response = await axios.get(
      api_url + `caisse/machine/${organisation_id}`,
      getConfig(),
    );
    return response;
  } catch (error) {
    return error?.response;
  }
}

export async function transferStockBetweenCaisses(transferData) {
  try {
    const response = await axios.post(
      api_url + `caisse/transfer-internal`,
      transferData,
      getConfig()
    );
    return response;
  } catch (error) {
    return error?.response;
  }
}

export async function getCaisseByUser(user_id, organisation_id) {
  try {
    const response = await axios.get(
      api_url + `caisse/user/${user_id}/${organisation_id}`,
      getConfig(),
    );
    return response;
  } catch (error) {
    return error?.response;
  }
}

export async function saveStockCaisses(
  productId,
  distributions,
  organisation_id,
) {
  try {
    const response = await axios.post(
      api_url + `caisse/stock`,
      { productId, distributions, organisation_id },
      getConfig(),
    );
    return response;
  } catch (error) {
    return error?.response;
  }
}

export async function getCaisseStock(caisseId) {
  try {
    const response = await axios.get(
      api_url + `caisse/stockCaisse/${caisseId}`,
      getConfig(),
    );
    return response;
  } catch (error) {
    return error?.response;
  }
}

// NEW FUNCTION: Get transfer history
export async function getTransferHistory(organisation_id, filters = {}) {
  try {
    const params = new URLSearchParams({
      ...filters,
      organisation_id
    }).toString();
    
    const response = await axios.get(
      api_url + `mouvements/transfers?${params}`,
      getConfig(),
    );
    return response;
  } catch (error) {
    return error?.response;
  }
}

// NEW FUNCTION: Get movements by type
export async function getMovementsByType(organisation_id, type = "transfert", limit = 10) {
  try {
    const response = await axios.get(
      api_url + `mouvements/type/${type}/${organisation_id}?limit=${limit}`,
      getConfig(),
    );
    return response;
  } catch (error) {
    return error?.response;
  }
}

// NEW FUNCTION: Get transfer by code
export async function getTransferByCode(code, organisation_id) {
  try {
    const response = await axios.get(
      api_url + `mouvements/code/${code}/${organisation_id}`,
      getConfig(),
    );
    return response;
  } catch (error) {
    return error?.response;
  }
}

// Local storage helpers
export const saveCaisseToStorage = (caisseData) => {
  localStorage.setItem(
    "caisse_data",
    JSON.stringify({
      ...caisseData,
      stored_at: new Date().toISOString(),
    }),
  );
};

export const getCaisseFromStorage = () => {
  const stored = localStorage.getItem("caisse_data");
  if (stored) {
    try {
      return JSON.parse(stored);
    } catch {
      return null;
    }
  }
  return null;
};

export const clearCaisseFromStorage = () => {
  localStorage.removeItem("caisse_data");
};